import { Suspense } from "react";
import { useParams } from "react-router";

import useProduct from "../../../../clients/products/useProduct";
import ProductDetail from "../features/detail/ProductDetail";

export default function ProductEdit() {
    const { productID } = useParams();

    const product = useProduct(productID);

    if (!product.data) {
        return "loading ...";
    }

    return (
        <Suspense fallback={ <div>loading</div> }>
            <ProductDetail
                product={
                    {
                        id: product.data.product.id,
                        ...product.data.product.recordedBy,
                        metadata: {
                            ...product.data.product.metadata,
                            ...product.data.product.recordedBy.metadata,
                        },
                    }
                }
            />
        </Suspense>
    );
}
